// 画面下中央の短い通知。連続で呼ばれても最後の 1 件だけが残るよう、タイマーを 1 本に保つ。
const TOAST_DURATION_MS = 2000;

export function createToast(el: HTMLElement): (message: string) => void {
  let timer: number | undefined;
  return (message: string) => {
    el.textContent = message;
    el.hidden = false;
    // 再表示のたびにアニメーションを頭から流す
    el.classList.remove("is-visible");
    void el.offsetWidth;
    el.classList.add("is-visible");

    if (timer !== undefined) clearTimeout(timer);
    timer = setTimeout(() => {
      el.classList.remove("is-visible");
      el.hidden = true;
    }, TOAST_DURATION_MS);
  };
}
